/* src/app/delivery-defense/dd-manage-subscription/cancel-subscription-popup/cancel-subscription-popup.component.scss */
.dialog-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
  height: 100%;
  flex-shrink: 0;
  border-radius: 4px;
  background: var(--ups-brand-colors-ups-teal-light, #F8FBFB);
  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
  padding: 1.63rem 0.5rem;
  position: relative;
  z-index: 0;
  overflow: auto;
}
.dialog-content h1,
.dialog-content h2,
.dialog-content h3 {
  margin: 0;
}
.dialog-content .content {
  padding: 1.26rem 0em 2.92rem;
  gap: 30px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  background: var(--ups-brand-colors-ups-teal-light, #F8FBFB);
}
@media only screen and (max-width: 32.6em) {
  .dialog-content .content {
    gap: 20px;
  }
}
.dialog-content .content .title {
  display: flex;
  width: 100%;
  height: 62px;
  flex-direction: column;
  justify-content: center;
}
.dialog-content .content .title .close-icon {
  position: absolute;
  top: 0.5rem;
  right: 0.75rem;
  z-index: 99;
}
.dialog-content .content .title h1 {
  text-align: center;
  font-feature-settings: "clig" off, "liga" off;
  font-family: "Roboto Flex", sans-serif;
  font-size: 33px;
  font-style: normal;
  font-weight: 600;
  line-height: 40px;
}
@media only screen and (max-width: 32.6em) {
  .dialog-content .content .title h1 {
    font-size: 30px;
  }
}
.dialog-content .content .dd-logo .logo {
  width: 248.733px;
  height: 90px;
}
@media only screen and (max-width: 32.6em) {
  .dialog-content .content .dd-logo .logo {
    width: 233.733px;
    height: 80px;
  }
}
.dialog-content .content h2 {
  display: flex;
  width: 100%;
  height: 54px;
  flex-direction: column;
  justify-content: center;
  flex-shrink: 0;
  color: #000;
  text-align: center;
  font-feature-settings: "clig" off, "liga" off;
  font-family: "Roboto Flex", sans-serif;
  font-size: 20px;
  font-style: normal;
  font-weight: 400;
  line-height: 32px;
}
@media only screen and (max-width: 32.6em) {
  .dialog-content .content h2 {
    width: 100%;
    margin-top: 1em;
    font-size: 16px;
  }
}
.dialog-content .content .featurePanel {
  display: flex;
  width: 100%;
  flex-direction: column;
  align-items: center;
  gap: 17px;
}
.dialog-content .content .featurePanel h3 {
  display: flex;
  width: 100%;
  height: 23px;
  flex-direction: column;
  justify-content: center;
  color: #000;
  text-align: center;
  font-feature-settings: "clig" off, "liga" off;
  font-family: "Roboto Flex", sans-serif;
  font-size: 25px;
  font-style: normal;
  font-weight: 400;
  line-height: 56px;
  text-decoration-line: underline;
}
@media only screen and (max-width: 32.6em) {
  .dialog-content .content .featurePanel h3 {
    margin-left: 23px;
  }
}
.dialog-content .content .featurePanel ul {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
@media only screen and (max-width: 32.6em) {
  .dialog-content .content .featurePanel ul {
    margin-left: -1em;
  }
}
.dialog-content .content .featurePanel ul li {
  margin: 0 0 10px 0;
  display: flex;
  width: 609px;
  align-items: center;
  gap: 11px;
  text-wrap: wrap;
  line-height: 1;
}
@media only screen and (max-width: 32.6em) {
  .dialog-content .content .featurePanel ul li {
    width: 100%;
  }
}
.dialog-content .content .featurePanel ul li .checkmark_1 {
  width: 24px;
  height: 24px;
  flex-shrink: 0;
  filter: invert(0) sepia(0) saturate(1) hue-rotate(45deg);
}
.dialog-content .content .featurePanel ul li .trademark {
  font-size: 16px;
}
@media only screen and (max-width: 32.6em) {
  .dialog-content .content .featurePanel ul li .trademark {
    font-size: 15px;
  }
}
.dialog-content .content .featurePanel ul li .trademark .ratedSymbal {
  margin-right: 6px;
  font-size: 11px;
  position: relative;
  top: -5px;
}
.dialog-content .content .featurePanel ul li .trademark .ratedtext {
  margin-left: -10px;
}
.dialog-content .content .featurePanel h5 {
  margin-top: -16px;
  display: flex;
  width: 800px;
  height: 34px;
  flex-direction: column;
  justify-content: center;
  color: #000;
  text-align: center;
  font-feature-settings: "clig" off, "liga" off;
  font-family: "Roboto Flex", sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
}
@media only screen and (max-width: 32.6em) {
  .dialog-content .content .featurePanel h5 {
    width: 100%;
    font-size: 12px;
  }
}
.dialog-content .content .actionButton {
  display: flex;
  gap: 35px;
  padding: 0px 10px 41px;
}
@media only screen and (max-width: 32.6em) {
  .dialog-content .content .actionButton {
    flex-direction: column;
    padding: 0px 10px 14px;
    gap: 22px;
    width: 90%;
    height: 48px;
    align-items: center;
  }
}
.dialog-content .content .actionButton .sbtsubscription {
  display: flex;
  width: 250px;
  height: 56px;
  padding: 10px 24px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  border-radius: 4px;
  border: 1px solid var(--ups-brand-colors-ups-teal, #0A8080);
  background: var(--ups-brand-colors-ups-teal, #0A8080);
  color: var(--ups-brand-colors-ups-white, #FFF);
  font-feature-settings: "clig" off, "liga" off;
  font-family: "Roboto Flex", sans-serif;
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
  line-height: 24px;
}
@media only screen and (max-width: 32.6em) {
  .dialog-content .content .actionButton .sbtsubscription {
    font-size: 17px;
    width: 90%;
    height: 48px;
  }
}
.dialog-content .content .actionButton .cancelbtn {
  display: flex;
  width: 250px;
  height: 56px;
  padding: 10px 24px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  border-radius: 4px;
  border: 1px solid var(--ups-brand-colors-ups-teal, #0A8080);
  background: var(--ups-brand-colors-ups-white, #FFF);
  color: var(--ups-brand-colors-ups-teal, #0A8080);
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
  line-height: 24px;
}
@media only screen and (max-width: 32.6em) {
  .dialog-content .content .actionButton .cancelbtn {
    font-size: 17px;
    width: 90%;
    height: 48px;
  }
}
.dialog-content .cancelPanel {
  padding: 3.26rem 0em 0.08rem;
  gap: 63px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 660px;
  background: var(--ups-brand-colors-ups-teal-light, #F8FBFB) !important;
}
@media only screen and (max-width: 32.6em) {
  .dialog-content .cancelPanel {
    gap: 50px;
    width: 100%;
  }
}
.dialog-content .cancelPanel .title {
  display: flex;
  width: 100%;
  height: 62px;
  flex-direction: column;
  justify-content: center;
}
.dialog-content .cancelPanel .title .close-icon {
  position: absolute;
  top: 0.5rem;
  right: 0.75rem;
  z-index: 99;
}
.dialog-content .cancelPanel .title h1 {
  display: flex;
  width: 100%;
  height: 74px;
  flex-direction: column;
  justify-content: center;
  font-feature-settings: "clig" off, "liga" off;
  font-family: "Roboto Flex", sans-serif;
  font-size: 40px;
  font-style: normal;
  font-weight: 400;
  line-height: 50px;
}
@media only screen and (max-width: 32.6em) {
  .dialog-content .cancelPanel .title h1 {
    font-size: 30px;
  }
}
.dialog-content .cancelPanel .cancelContent {
  width: 684px;
  background: var(--ups-brand-colors-ups-teal-light, #F8FBFB);
}
@media only screen and (max-width: 32.6em) {
  .dialog-content .cancelPanel .cancelContent {
    width: 100%;
  }
}
.dialog-content .cancelPanel .cancelContent .mat-mdc-form-field {
  width: 660px;
  padding: 16px 0px;
}
.dialog-content .cancelPanel .cancelContent .mat-mdc-form-field.borderActive {
}
.dialog-content .cancelPanel .cancelContent .mat-mdc-form-field.borderActive ::ng-deep .mat-form-field-outline {
  color: #5F5753 !important;
}
@media only screen and (max-width: 32.6em) {
  .dialog-content .cancelPanel .cancelContent .mat-mdc-form-field {
    width: 100%;
    font-size: 21px;
    padding: 0px;
  }
}
.dialog-content .cancelPanel .cancelContent .mat-mdc-form-field .mat-select-content {
  font-size: 18px !important;
}
.dialog-content .cancelPanel .cancelContent .dropdown h2 {
  width: 549px;
  height: 35px;
  color: #000;
  font-feature-settings: "clig" off, "liga" off;
  font-family: "Roboto Flex", sans-serif;
  font-size: 25.6px;
  font-style: normal;
  font-weight: 400;
  line-height: 38.4px;
}
@media only screen and (max-width: 32.6em) {
  .dialog-content .cancelPanel .cancelContent .dropdown h2 {
    width: 97%;
    font-size: 19px;
    margin-top: 1.5em;
    margin-bottom: 2em;
  }
}
.dialog-content .cancelPanel .cancelContent .description h2 {
  width: 549px;
  height: 35px;
  color: #000;
  font-feature-settings: "clig" off, "liga" off;
  font-family: "Roboto Flex", sans-serif;
  font-size: 25.6px;
  font-style: normal;
  font-weight: 400;
  line-height: 38.4px;
}
@media only screen and (max-width: 32.6em) {
  .dialog-content .cancelPanel .cancelContent .description h2 {
    width: 97%;
    font-size: 19px;
  }
}
.dialog-content .cancelPanel .cancelContent .dropdown {
  width: 660px;
  background: var(--ups-brand-colors-ups-teal-light, #F8FBFB);
}
@media only screen and (max-width: 32.6em) {
  .dialog-content .cancelPanel .cancelContent .dropdown {
    width: 100%;
  }
}
.dialog-content .cancelPanel .cancelContent .dropdown .ups-form {
  background: var(--ups-brand-colors-ups-teal-light, #F8FBFB) !important;
}
.dialog-content .cancelPanel .cancelContent .dropdown .ups-form .ddPanel .selectPanel {
}
.dialog-content .cancelPanel .cancelContent .dropdown .ups-form .ddPanel .selectPanel .mat-select-placeholder {
  color: red !important;
}
.dialog-content .cancelPanel .cancelContent .dropdown .ups-form .description .descrpPanel {
  resize: none;
  display: flex;
  width: 660px;
  height: 107px;
  padding: 16px;
  align-items: center;
  gap: 16px;
  border-radius: 6.4px;
  border: 1.6px solid #5F5753;
  background: #FFF;
}
@media only screen and (max-width: 32.6em) {
  .dialog-content .cancelPanel .cancelContent .dropdown .ups-form .description .descrpPanel {
    width: 100%;
  }
}
.dialog-content .cancelPanel .cancelContent .description .descrpPanel {
  resize: none;
  display: flex;
  width: 660px;
  height: 107px;
  padding: 16px;
  align-items: center;
  gap: 16px;
  border-radius: 6.4px;
  border: 1.6px solid #5F5753;
  background: #FFF;
}
@media only screen and (max-width: 32.6em) {
  .dialog-content .cancelPanel .cancelContent .description .descrpPanel {
    width: 100%;
  }
}
.dialog-content .cancelPanel .actionButton {
  display: flex;
  gap: 35px;
}
@media only screen and (max-width: 32.6em) {
  .dialog-content .cancelPanel .actionButton {
    flex-direction: column;
    padding: 0px 10px 14px;
    gap: 22px;
    width: 90%;
    height: 48px;
    align-items: center;
  }
}
.dialog-content .cancelPanel .actionButton .keepSubscription {
  display: flex;
  width: 200px;
  height: 56px;
  padding: 10px 24px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  border-radius: 4px;
  border: 1px solid var(--ups-brand-colors-ups-teal, #0A8080);
  background: var(--ups-brand-colors-ups-teal, #0A8080);
  color: var(--ups-brand-colors-ups-white, #FFF);
  font-feature-settings: "clig" off, "liga" off;
  font-family: "Roboto Flex", sans-serif;
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  line-height: 24px;
}
@media only screen and (max-width: 32.6em) {
  .dialog-content .cancelPanel .actionButton .keepSubscription {
    font-size: 16px;
    font-weight: 500;
    width: 90%;
    height: 48px;
  }
}
.dialog-content .cancelPanel .actionButton .submit {
  display: flex;
  width: 200px;
  height: 56px;
  padding: 10px 24px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  border-radius: 4px;
  border: 1px solid var(--ups-brand-colors-ups-teal, #0A8080);
  background: var(--ups-brand-colors-ups-white, #FFF);
  color: var(--ups-brand-colors-ups-teal, #0A8080);
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
  line-height: 24px;
}
@media only screen and (max-width: 32.6em) {
  .dialog-content .cancelPanel .actionButton .submit {
    font-size: 16px;
    font-weight: 500;
    width: 90%;
    height: 48px;
  }
}
.dialog-content .submittedPanel {
  padding: 3.26rem 0em 0.08rem;
  gap: 100px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 675px;
  background: var(--ups-brand-colors-ups-teal-light, #F8FBFB) !important;
}
@media only screen and (max-width: 32.6em) {
  .dialog-content .submittedPanel {
    gap: 80px;
    width: 100%;
  }
}
.dialog-content .submittedPanel .title {
  display: flex;
  width: 100%;
  height: 72px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.dialog-content .submittedPanel .title .close-icon {
  position: absolute;
  top: 0.5rem;
  right: 0.75rem;
  z-index: 99;
}
.dialog-content .submittedPanel .title h1 {
  display: flex;
  width: 100%;
  height: 62px;
  flex-direction: column;
  justify-content: center;
  color: #000;
  text-align: center;
  font-feature-settings: "clig" off, "liga" off;
  font-family: "Roboto Flex", sans-serif;
  font-size: 45px;
  font-style: normal;
  font-weight: 400;
  line-height: 40px;
}
@media only screen and (max-width: 32.6em) {
  .dialog-content .submittedPanel .title h1 {
    font-size: 36px;
  }
}
.dialog-content .submittedPanel .title .separator {
  width: 100px;
  height: 4px;
  background: #0A8080;
  margin-top: 15px;
}
.dialog-content .submittedPanel .dialog-header {
  background: var(--ups-brand-colors-ups-teal-light, #F8FBFB) !important;
  position: relative;
}
.dialog-content .submittedPanel .dialog-header .header {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.dialog-content .submittedPanel .dialog-header .header h1 {
  display: flex;
  width: 820px;
  height: 62px;
  flex-direction: column;
  justify-content: center;
  color: #000;
  text-align: center;
  font-feature-settings: "clig" off, "liga" off;
  font-family: "Roboto Flex", sans-serif;
  font-size: 45px;
  font-style: normal;
  font-weight: 400;
  line-height: 40px;
  margin-top: 2em;
}
.dialog-content .submittedPanel .dialog-header .header .separator {
  width: 100px;
  height: 4px;
  background: #0A8080;
  margin-top: 15px;
}
.dialog-content .submittedPanel .dialog-header .close-button .material-icons {
  width: 16px;
  height: 15.934px;
  flex-shrink: 0;
  color: #000;
  margin-top: 1em;
  margin-right: 1em;
}
@media only screen and (max-width: 32.6em) {
  .dialog-content .submittedPanel .cancelContent {
    width: 100%;
  }
}
.dialog-content .submittedPanel .cancelContent h1 {
  color: #000;
  font-feature-settings: "clig" off, "liga" off;
  font-family: "Roboto Flex", sans-serif;
  font-size: 28px;
  font-style: normal;
  font-weight: 400;
  line-height: 36px;
}
.dialog-content .submittedPanel .actionButton {
  display: flex;
  gap: 35px;
  padding: 0px 10px 41px;
}
@media only screen and (max-width: 32.6em) {
  .dialog-content .submittedPanel .actionButton {
    flex-direction: column;
    padding: 0px 10px 14px;
    gap: 22px;
    width: 90%;
    height: 48px;
    align-items: center;
  }
}
.dialog-content .submittedPanel .actionButton .restartSubscription {
  display: flex;
  width: 387px;
  height: 56px;
  padding: 10px 24px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  border-radius: 4px;
  border: 1px solid var(--ups-brand-colors-ups-teal, #0A8080);
  background: var(--ups-brand-colors-ups-teal, #0A8080);
  color: var(--ups-brand-colors-ups-white, #FFF);
  font-feature-settings: "clig" off, "liga" off;
  font-family: "Roboto Flex", sans-serif;
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
  line-height: 24px;
}
@media only screen and (max-width: 32.6em) {
  .dialog-content .submittedPanel .actionButton .restartSubscription {
    font-size: 18px;
    font-weight: 500;
    width: 90%;
    height: 48px;
  }
}
button.tab-trap {
  width: 0;
  height: 0;
  position: absolute;
  left: -9999px;
}
.actionButton .mdc-button {
  padding: 1.5em 2em;
  font-size: 1rem;
}
/*# sourceMappingURL=cancel-subscription-popup.component.css.map */
